import { NgModule } from '@angular/core';
import { FormFocusOnInvalidDirective } from './form-focus-on-invalid.directive';

@NgModule({
  declarations: [FormFocusOnInvalidDirective],
  exports: [FormFocusOnInvalidDirective],
})
export class FormFocusOnInvalidDirectiveModule {}
